module.exports = __webpack_public_path__ + "img/introduction.79c232be.jpg";